import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';
import bg from '../../assets/images/agentWorkingEmptyStateBackground.png';

export const AgentWorkingEmptyState = () => {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    import('../../assets/lotties/star-magic-white.json').then((module) =>
      setAnimationData(module.default),
    );
  }, []);
  return (
    <div className="relative flex h-full w-full flex-col items-center justify-start overflow-hidden rounded-tl-2xl rounded-tr-2xl bg-[#fbfaff]">
      <img
        src={bg}
        alt="Background"
        className="absolute inset-0 h-full w-full object-cover object-top-left"
      />
      <div className="relative flex h-full w-full flex-col items-center justify-center gap-8 px-4 py-8">
        <div
          className="h-full max-h-[180px] w-full max-w-[360px] shrink-0 overflow-hidden rounded-3xl border border-white/50 bg-linear-to-b from-white/6 to-white/10 px-3 py-4 backdrop-blur-[3px]"
          style={{ boxShadow: '3px 3px 10px 0 rgba(88,71,206,0.04)' }}
        >
          <div className="flex items-center justify-between px-2.5 pb-4">
            <div className="relative flex items-center justify-start gap-[7px]">
              <svg
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid meet"
              >
                <circle cx="4.5" cy="4.5" r="4.5" fill="#FA6857" />
              </svg>
              <svg
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid meet"
              >
                <circle cx="4.5" cy="4.5" r="4.5" fill="#FBBD3F" />
              </svg>
              <svg
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid meet"
              >
                <circle cx="4.5" cy="4.5" r="4.5" fill="#1FC747" />
              </svg>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <div className="relative mt-2 h-24 w-24">
              {animationData && (
                <Lottie
                  animationData={animationData}
                  loop={true}
                  className="absolute top-1/2 left-1/2 size-15 -translate-x-1/2 -translate-y-1/2"
                />
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-start gap-4">
          <div className="flex flex-col items-center justify-start gap-4">
            <p className="text-center text-3xl font-medium text-[#141c25] md:text-4xl">
              Working on it…
            </p>
            <p className="text-center text-sm text-[#637083]">
              the magic is happening
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
